module.exports = __webpack_public_path__ + "media/images/favicon-ac8880ea0884543d42265457d0a31fe8.svg";